import React from "react"
import { PageProps } from "gatsby"
import { useIntl } from "gatsby-plugin-intl"
import * as styles from "./fullСycledevelopment.module.scss"

import Layout from "../../components/Layout/Layout"
import SEO from "../../components/seo"
import SecondTitle from "../../components/UI/SecondTitle/SecondTitle"
import ScrollSpyMenu from "../../components/UI/ScrollSpyMenu/ScrollSpyMenu"

const archiveList = [
	{ img: "/images/full-cycle-software/unique-icon.svg", title: "full-cycle.archive-block.uniqueness" },
	{ img: "/images/full-cycle-software/transparency-icon.svg", title: "full-cycle.archive-block.transparency" },
	{ img: "/images/full-cycle-software/access-icon.svg", title: "full-cycle.archive-block.security" },
	{ img: "/images/full-cycle-software/protection-icon.svg", title: "full-cycle.archive-block.efficiency" },
];


const benefitsList = [
	{ title: "full-cycle.benefits.uniqueness", text: "full-cycle.benefits.uniqueness-text" },
	{ title: "full-cycle.benefits.transparency", text: "full-cycle.benefits.transparency-text" },
	{ title: "full-cycle.benefits.security", text: "full-cycle.benefits.security-text" },
	{ title: "full-cycle.benefits.efficiency", text: "full-cycle.benefits.efficiency-text" },
];


const fullCycleDevelopment: React.FC<PageProps> = ({ location }) => {
	const intl = useIntl()

	return (
		<Layout location={location}>
			<SEO
				language={intl.locale}
				description={intl.formatMessage({ id: "full-cycle.seo.description" })}
				title={intl.formatMessage({ id: "full-cycle.seo.title" })}
				pathname={location.pathname}
			/>
			<SecondTitle desktopImage="/images/pages-heading/full-cycle-title.png" mobileImage="/images/pages-heading/full-cycle-title-m.png" title={intl.formatMessage({ id: "full-cycle.title-block.title" })} position="right center" />
			<div className={styles.container}>
				<section className={styles.intro}>
					<h2>{intl.formatMessage({ id: "full-cycle.title-block.subtitle" })}</h2>
					<p>{intl.formatMessage({ id: "full-cycle.title-block.text1" })}</p>
					<p>{intl.formatMessage({ id: "full-cycle.title-block.text2" })}</p>
					<p>{intl.formatMessage({ id: "full-cycle.title-block.text3" })}</p>
				</section>
				<ul className={styles.archiveList}>
					{
						archiveList.map((item, index) => (
							<li className={styles.archiveItem} key={index}>
								<img src={item.img} alt={item.title} />
								<h3>{intl.formatMessage({ id: item.title })}</h3>
							</li>
						))
					}
				</ul>
				<div className={styles.banner}>
					<h2>{intl.formatMessage({ id: "full-cycle.banner" })}</h2>
				</div>

				<ScrollSpyMenu />

				<section className={styles.benefits}>
					<h2>Client Benefits</h2>
					<ul className={styles.benefitsList}>
						{
							benefitsList.map((item, index) => (
								<li key={index} className={styles.benefitsItem}>
									<h3>{intl.formatMessage({ id: item.title })}</h3>
									<p>{intl.formatMessage({ id: item.text })}</p>
								</li>
							))
						}
					</ul>
				</section>

			</div>
		</Layout>
	)
}

export default fullCycleDevelopment;
